<form
  id="mu-auth-person-billing-form"
  class="p-grid p-dir-col mu-position-relative mu-form-content"
  [formGroup]="formData"
  appValidator
  *ngIf="formData"
>
  <div class="p-grid container-form mu-full-width">
    <app-mu-form-fieldset [customGridCol]="12" label="fullName" [iconFeedback]="true">
      <input type="text" id="fullName" formControlName="fullName" [placeholder]="'form.placeholder.fullName' | translate" />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset
      [customGridCol]="showZipCode ? 8 : 12"
      label="city"
      [iconFeedback]="true"
      [position]="showZipCode ? fieldPositionEnum.START : ''"
      [attr.translate]="'no'"
    >
      <app-mu-form-dropdown [formGroup]="formData" field="city" [optionList]="cityList"></app-mu-form-dropdown>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="4" label="zipCode" [iconFeedback]="true" *ngIf="showZipCode" [position]="fieldPositionEnum.END">
      <input type="text" id="zipCode" name="zipCode" formControlName="zipCode" [placeholder]="'form.placeholder.zipCode' | translate" />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="12" label="documentType" [iconFeedback]="true">
      <app-mu-form-dropdown [formGroup]="formData" field="documentType" [optionList]="documentTypeList"></app-mu-form-dropdown>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="12" label="documentNumber" [iconFeedback]="true">
      <input
        type="text"
        fullName="documentNumber"
        id="documentNumber"
        formControlName="documentNumber"
        [placeholder]="'form.placeholder.documentNumber' | translate"
      />
    </app-mu-form-fieldset>
  </div>
  <app-mu-form-buttons [customGridCol]="12">
    <p-button
      muButtonLeft
      [label]="'form.button.back' | translate"
      class="mu-button mu-button-outline"
      type="button"
      routerLink="/crear-cuenta/datos"
    >
    </p-button>
    <p-button
      muButtonRight
      [label]="'form.button.selfRegister' | translate"
      [disabled]="formData?.get('isInvalidForm').value"
      class="mu-button"
      type="button"
      (click)="register()"
    >
      <app-loading [showLoading]="loader" type="icon"></app-loading>
    </p-button>
  </app-mu-form-buttons>
</form>
